import { formatCountdown } from '@/shared/lib/time-utils';
import { useCountdownTimer } from '@/shared/lib/use-countdown-timer';

type CountdownProps = {
    deadlineAt: number;
    onFinish?: () => void;
};

export function Countdown({ deadlineAt, onFinish }: CountdownProps) {
    const { remaining } = useCountdownTimer({ deadlineAt, onFinish });

    return <>{formatCountdown(remaining)}</>;
}
